/**
 * Company: SPHMedia
 * Description: [A button component for navigating the custom carousel]
 */

import ChevronImage from "@assets/video_widget/Chevron.webp";
import BackChevronImage from "@assets/video_widget/Right.webp";
import { ReactElement } from "react";
import { twMerge } from "tailwind-merge";

type CustomCarouselButtonProps = {
  direction: "next" | "prev";
  variant: "enabled" | "disabled";
  onClick: () => void;
};

export default function CustomCarouselButton({
  direction,
  variant,
  onClick,
}: CustomCarouselButtonProps): ReactElement {
  const isDisabled = variant === "disabled";
  const isPrevious = direction === "prev";

  return (
    <button
      type="button"
      aria-label={direction}
      disabled={isDisabled}
      onClick={onClick}
      className={twMerge(
        "flex h-[38px] w-[38px] items-center justify-center rounded-full bg-white shadow-[0px_0px_8px_0px_#00000026] transition-all",
        isDisabled && "cursor-not-allowed opacity-60",
        !isDisabled && "cursor-pointer hover:shadow-lg",
      )}
    >
      <img
        src={isDisabled ? BackChevronImage : ChevronImage}
        alt={`${direction}-arrow`}
        className={twMerge(
          "h-7 w-7",
          // Enabled previous button
          isPrevious && !isDisabled && "rotate-180",
          // Disabled next button
          !isPrevious && isDisabled && "rotate-180",
        )}
      />
    </button>
  );
}
